import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Modal from "app/modules/common/component/Modal";

class JobInfoModal extends PureComponent {
  componentWillMount() {}

  handleOnClose = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch({
      type: "MODAL",
      data: {
        isOpen: false,
      },
    });
  };

  render() {
    return (
      <div>
        <form>
          <Modal.Body>
            <div className="modal-body job-info">
              <div className="mb-5">
                <p>
                  These are the important things that you need to include in
                  your resume which are critical in our review and our
                  employers' review:
                </p>

                <ul>
                  <li>
                    <b>Work Experience:</b> List your work experience in reverse
                    chronological order which means you have to start with your
                    most recent position and work your way backwards. Put
                    emphasis on your main responsibilities. Complete job
                    description and duties must be enumerated. This is critical
                    in our review of your credentials. IMPORTANT NOTE: If you
                    have gaps between your work experiences, they must all be
                    indicated. (ex. Sept 2010 - Jan 2011, unemployed because of
                    family emergency)
                  </li>
                  <li>
                    <b>Educational Background:</b> You should also list your
                    educational background (from your highest educational
                    attainment to elementary). Start from the most recent
                    qualification. Pay attention to your internships for fresh
                    graduates. You may leave irrelevant qualifications.
                  </li>
                  <li>
                    <b>Major Achievements, Certifications, Licensure, etc</b>{" "}
                    (if any): These can land you to your dream job. You should
                    list them. Again your achievements should be relevant to
                    what an employer is looking for.
                  </li>
                  <li>
                    <b>Language:</b> List down the languages that you can speak.
                    This is optional.
                  </li>
                  <li>
                    <b>Hobbies/Interests:</b> These can help if you are a fresh
                    graduate. Your employer can relate to these. This is also
                    optional.
                  </li>
                  <li>
                    <b>References:</b> Have a list of character references and
                    their contact details like your former employer or
                    professor.
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        </form>
      </div>
    );
  }
}

const mapPropsToState = (state, props) => {
  const form_data = state.auth.get("form_data");
  const profile = state.auth.get("profile");
  const job_details = state.auth.get("job_details");
  return {
    form_data,
    profile,
    job_details,
  };
};

export default withRouter(connect(mapPropsToState)(JobInfoModal));
